export default __webpack_public_path__ + "static/animal-debt-back-banner-50a2fd0dec4bf97a1725281a0af308d6.webp";